import { Path } from "@constellation-academy/epic-ui";
import { FeatureTogglesPath } from "../feature-toggles";

export class SettingsPath extends Path<typeof SettingsPath> {
	static readonly pathKey = "settings";
	static readonly childPaths = [FeatureTogglesPath];
}
